<template>
  <div class="input" :style="containerStyle" :data-focus="inputFocus">
    <span class="input-icon left" v-if="icon && iconFloat === 'left'" @click="$emit('icon')">
      <i class="icon" :class="icon"></i>
    </span>
    <input
      :type="type"
      :disabled="disabled"
      :placeholder="placeholder"
      :value="value"
      @input="$emit('input', $event.target.value)"
      @focus="inputFocus = true"
      @blur="inputFocus = false"
      :autocomplete="type === 'password' ? 'off' : 'on'"
      :maxlength="maxlength"
    />
    <span class="input-icon right" v-if="icon && iconFloat === 'right'" @click="$emit('icon')">
      <i class="icon" :class="icon"></i>
    </span>
    <div v-if="unit" class="input-unit" :style="unitStyle">{{unitFormated}}</div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: '...'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Array],
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    iconFloat: {
      type: String,
      default: 'left'
    },
    unit: {
      type: [Number, String],
      default: ''
    },
    height: {
      type: String,
      default: '47px'
    },
    width: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number,
      default: 1000
    }
  },
  data () {
    return {
      inputFocus: false
    }
  },
  computed: {
    containerStyle () {
      let style = ''
      if (this.height) {
        style += `height:${this.height}`
      }
      if (this.width) {
        style += `;width:${this.width}`
      }
      return style
    },
    unitStyle () {
      let right = 14
      if (this.icon) {
        if (this.iconFloat === 'right') {
          right += 37
        }
      }
      return `right: ${right}px;`
    },
    unitFormated () {
      if (this.unit) {
        switch (this.unit) {
          case 10000:
            return '万'
          default:
            return ''
        }
      }
      return ''
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.input {
  display: flex;
  align-items: center;
  position: relative;

  border-color: var(--colorGray4);
  border-width: 1px;
  border-style: solid;
  @media (--mediaPc) {
    font-size: var(--textSize4);
    border-radius: var(--borderRadius3);
  }
  @media (--mediaMobile) {
    font-size: var(--textSize3Mobile);
    border-radius: var(--borderRadius3Mobile);
  }
  &[data-focus="true"] {
    border-color: var(--colorMain);
  }
  & input {
    appearance: textfield;

    width: 100%;
    height: 100%;
    border: 0;
    box-sizing: border-box;
    outline: none;

    text-indent: 0;
    padding-left: 14px;
    &::placeholder {
      color: var(--colorDisabled);
    }
  }
  & .input-icon {
    color: var(--colorDisabled);
    &.left {
      padding-left: 17px;
    }
    &.right {
      padding-right: 17px;
    }
  }
  & .input-unit {
    @media (--mediaPc) {
      padding-right: 11px;
    }
    @media (--mediaMobile) {
      padding-right: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/input/BaseInput.vue